import CheckboxControl from './CheckboxControl';
import FormControlLabel, { FormControlLabelProps } from '../FormControlLabel';

export interface CheckboxProps extends Omit<FormControlLabelProps, 'control'> {
  control?: FormControlLabelProps['control'];
}

export default function Checkbox(props: CheckboxProps) {
  return <FormControlLabel control={<CheckboxControl />} {...props} />;
}
